import { render, staticRenderFns } from "./TrailerVideo.vue?vue&type=template&id=b818cadc&scoped=true&"
import script from "./TrailerVideo.vue?vue&type=script&lang=ts&"
export * from "./TrailerVideo.vue?vue&type=script&lang=ts&"
import style0 from "./TrailerVideo.vue?vue&type=style&index=0&id=b818cadc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b818cadc",
  null
  
)

export default component.exports